export default "__VITE_ASSET__Cw0L_vTQ__";